import { MockRestCall } from "@/common/api/ApiResult.model";
import { RestCallsKey } from "../demo/rest.resolver";

export const risky_users_gql = {
  "risky-users.count-approximation": {
    delay: 1000,
    payload: async () => {
      const { SharedState } = await import("@/common/state");
      return SharedState.l0InfoTypes.value.reduce((acc, l0) => {
        acc[l0.id] = 5;
        return acc;
      }, {} as Record<string, number>);
    },
  },
};
// @ts-ignore
export const risky_users: Record<Partial<RestCallsKey>, MockRestCall> = {
  /*  "risky-users.status-list": {
    delay: 1000,
    payload: async () => {
      const { SharedState } = await import("@/common/state");
      return SharedState.l0InfoTypes.value.map(({ id, labelName }, index) => {
        return {
          id,
          name: labelName,
          is_active: index % 2 === 0,
          next_send_date: "2022-10-16T14:00:39.000Z",
        };
      });
    },
  },
   */
  "risky-users.change-activate-for-l0": {
    delay: 0,
    payload: () => true,
  },
  "risky-users.for-l0": {
    delay: 1000,
    payload: async () => {
      const { SharedState } = await import("@/common/state");
      return {
        cursor: "",
        objects: Object.entries(SharedState.employees_full_objects.value)
          .slice(0, 10)
          .map(([id, { dep_name, email, name }], index) => {
            const score = Math.floor(Math.random() * 300);
            return {
              id: id,
              name: name,
              // @ts-ignore
              department: dep_name,
              email: email,
              score: score,
              isTrusted: score > 200,
            };
          })
          .sort((a, b) => b.score - a.score),
      };
    },
  },
};
